import { isAxiosError } from "axios";
import type { z } from "zod/v4";

/**
 * The typed conflict a 409 carries as its error envelope's `data` — a dataset
 * write or delete, a Source delete, or a generated-tests adopt, refused for a
 * reason the caller can act on — parsed with the refusing route's schema, or
 * null for any other failure. The dialogs render it inline rather than as a
 * toast, because it names what to do next.
 */
export const getAgenticLogicConflict = <T>(
  error: unknown,
  schema: z.ZodType<T>
): T | null => {
  if (!isAxiosError(error) || error.response?.status !== 409) return null;
  const parsed = schema.safeParse(
    (error.response.data as { data?: unknown } | undefined)?.data
  );
  return parsed.success ? parsed.data : null;
};
